module.exports = __webpack_public_path__ + "img/invisible.028ee7a2.svg";